<template>
  <div>
    <div class="controlls-top">
      <i-button slot="top-buttons" type="primary" size="large" @click="sync_users">
        {{ $t('integrations.button.sync_users') }}
      </i-button>
    </div>
    <table-component />
  </div>
</template>

<script>
  import TableComponent from '@integrations/components/users-table';
  import { mapActions } from 'vuex';
  import { AmoService } from '@amo-widget/services/AmoService';

  export default {
    components: { TableComponent },

    methods: {
      ...mapActions('amo_widget/users/table', ['getAsyncData']),

      sync_users: function () {
        AmoService.syncUsers()
          .then(() => {
            this.$router.go();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };
</script>
